var React = require('react');

function Tech (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0, 0)"},[React.createElement("path",{"data-color":"color-2","d":"M31.718,22.55l-4.007-1.939-10.622,5.14a2.5,2.5,0,0,1-2.175,0L4.289,20.611.282,22.55a.5.5,0,0,0,0,.9l15.5,7.5a.5.5,0,0,0,.436,0l15.5-7.5a.5.5,0,0,0,0-.9Z","key":0}),React.createElement("path",{"data-color":"color-2","d":"M31.718,15.55l-4.007-1.939-10.622,5.14a2.5,2.5,0,0,1-2.175,0L4.289,13.611.282,15.55a.5.5,0,0,0,0,.9l15.5,7.5a.5.5,0,0,0,.436,0l15.5-7.5a.5.5,0,0,0,0-.9Z","key":1}),React.createElement("path",{"d":"M31.718,8.55l-15.5-7.5a.5.5,0,0,0-.436,0L.282,8.55a.5.5,0,0,0,0,.9l15.5,7.5a.5.5,0,0,0,.436,0l15.5-7.5a.5.5,0,0,0,0-.9Z","key":2})]));
}

Tech.defaultProps = {"x":"0px","y":"0px","width":"32px","height":"32px","viewBox":"0 0 32 32"};

module.exports = Tech;

Tech.default = Tech;
